module.exports = __webpack_public_path__ + "static/media/applicationlink.740ddbdc.png";